import React from "react"
import { connect } from "react-redux"
import UnlockPremium from "./UnlockPremium"
import { Modal, Button as AButton } from "antd"
import { CheckIcon } from "../core/icons"

import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect
} from "react-router-dom"

import styled from "styled-components"
import { AllIntegrations } from "../account/integrations/index"
import { push, goBack } from "react-router-redux"

export const Button = styled(AButton).attrs({
  type: props => props.primary && "primary"
})`
  font-size: 18px;
  margin-top: 12px;

  ${props =>
    props.fullWidth &&
    `
    width: 100%;
    height: 42px;
  `};
`

const Body = styled.div`
  padding: 4vmin;
  font-size: large;

  h1 {
  }
`

const IntegrationsModal = ({ dispatch, message, title, buttonText }) => (
  <Modal
    size="large"
    bodyStyle={{ padding: 0 }}
    visible={true}
    width={800}
    onOk={() => {
      // other action
      dispatch({ type: "HIDE_MODAL_2" })
    }}
    onCancel={() => dispatch({ type: "HIDE_MODAL_2" })}
    footer={null}
  >
    <Body>
      <h1>{title}</h1>
      <br />
      <AllIntegrations />
      <br />
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end"
          // padding: "0 40px"
        }}
      >
        <Button onClick={() => dispatch({ type: "HIDE_MODAL_2" })}>
          {buttonText}
        </Button>
      </div>
    </Body>
  </Modal>
)

export default connect(
  // ownProps in this case are modalProps passed from the action or reducer
  (state, ownProps) => ({})
)(IntegrationsModal)



// WEBPACK FOOTER //
// ./src/modal/IntegrationsModal.js